import {CashManagementSubsteps} from 'core/_consts';
import {FC, useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import IsLockboxNeeded from './IsLockboxNeeded';
import SelectLockboxType from './SelectLockboxType';

type CashManagementSubstepsKeys = keyof typeof CashManagementSubsteps;

const CashManagament: FC = () => {
  const location = useLocation();
  const [substep, setSubstep] = useState<CashManagementSubstepsKeys | null>();

  useEffect(() => {
    setSubstep(new URLSearchParams(location.search).get('substep') as CashManagementSubstepsKeys);
  }, [location.search]);

  switch (substep) {
    case CashManagementSubsteps[CashManagementSubsteps.isLockboxNeeded]:
      return <IsLockboxNeeded />;

    case CashManagementSubsteps[CashManagementSubsteps.selectLockboxType]:
      return <SelectLockboxType />;

    default:
      return null;
  }
};

export default CashManagament;
